module.exports = __webpack_public_path__ + "static/img/shangbiao_25.66b9d61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shangbiao_25.png
// module id = zvTa
// module chunks = 0